import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const Navbar = { id: 5, name: 'Navbar' };
export const chatIconVisibility = defineFeature({
    type: FeatureType.Boolean,
    propName: 'chat_icon_visibility',
    uiName: 'chatIconVisibility',
    displayName: 'Chat Icon',
    description: 'Toggles the display the Chat icon in the header',
    category: Navbar,
    areas: ['application'],
    codec: 'identity',
    schema: z.boolean(),
    default: true,
    isSystem: true,
});
export const supportIcon = defineFeature({
    type: FeatureType.Markdown,
    propName: 'support_icon',
    uiName: 'supportIcon',
    displayName: 'Support',
    description: 'Support Modal Content',
    category: Navbar,
    areas: ['application'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
});
export const documentIconVisibility = defineFeature({
    type: FeatureType.Boolean,
    propName: 'document_icon_visibility',
    uiName: 'documentIconVisibility',
    displayName: 'Documents',
    description: 'Toggles the display the Documents icon in the header',
    category: Navbar,
    areas: ['application'],
    codec: 'identity',
    schema: z.boolean(),
    default: true,
    isSystem: true,
});
export const homeButton = defineFeature({
    type: FeatureType.Boolean,
    propName: 'home_button',
    uiName: 'homeButton',
    displayName: 'Home Button',
    description: 'Enable/disable home button in header',
    category: Navbar,
    areas: ['application'],
    codec: 'identity',
    schema: z.boolean(),
    default: false,
    isSystem: true,
});
export const homeButtonTopHeader = defineFeature({
    type: FeatureType.Boolean,
    propName: 'home_button_top_header',
    uiName: 'homeButtonTopHeader',
    displayName: 'Home Button Top Header',
    description: 'Enable/Disable the home button in the top header next to documentation',
    category: Navbar,
    areas: ['application'],
    codec: 'identity',
    schema: z.boolean(),
    default: true,
    isSystem: true,
});
export const applicationTooltip = defineFeature({
    type: FeatureType.String,
    propName: 'application_tooltip',
    uiName: 'applicationTooltip',
    displayName: 'Application Tooltip',
    description: 'Configure tooltip text that appears on fresh session and on hover for navbar application icon. Leave empty to disable tooltip',
    category: Navbar,
    areas: ['application'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
    flatModelSchema: z.string().nullable(),
});
export const faqIcon = defineFeature({
    type: FeatureType.Boolean,
    propName: 'faq_icon',
    uiName: 'faqIcon',
    displayName: 'FAQ Icon',
    description: 'Enable the FAQ icon in the chat header',
    category: Navbar,
    areas: ['application'],
    surfacedIn: ['application'],
    codec: 'identity',
    schema: z.boolean(),
    default: false,
    isSystem: true,
});
export const faqChatContextIdentifier = defineFeature({
    type: FeatureType.String,
    propName: 'faq_chat_context_identifier',
    uiName: 'faqChatContextIdentifier',
    displayName: 'FAQ Chat Context Identifier',
    description: "Identifier of the chat context to use as this application's FAQ. The context must be added to the application's Chat Contexts list. Leave empty to hide the FAQ icon.",
    category: Navbar,
    areas: ['application'],
    surfacedIn: ['application'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
    editor: 'chat-context-select',
    requiresFeature: ['faq_icon'],
});
export const navbarFeatures = [
    chatIconVisibility,
    supportIcon,
    documentIconVisibility,
    homeButton,
    homeButtonTopHeader,
    applicationTooltip,
    faqIcon,
    faqChatContextIdentifier,
];
